import React from 'react';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { EmployerDashboard } from './employer/EmployerDashboard';
import { EmployeeDashboard } from './employee/EmployeeDashboard';

export const MainDashboard: React.FC = () => {
  const { user } = useTypedSelector(state => state);

  return <>{!!user?.uuid && <>{user.isCompanyAdmin ? <EmployerDashboard /> : <EmployeeDashboard />}</>}</>;
};
